import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  TextField,
  InputAdornment
} from '@mui/material';
import {
  Search as SearchIcon,
  Book as BookIcon,
  Security as SecurityIcon,
  ContactSupport as ContactSupportIcon,
  Assignment as AssignmentIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const HelpCenter = () => {
  const { t } = useTranslation();

  const categories = [
    {
      icon: <BookIcon fontSize="large" />,
      title: t('help.categories.gettingStarted.title'),
      description: t('help.categories.gettingStarted.description'),
      link: '/help/getting-started'
    },
    {
      icon: <SecurityIcon fontSize="large" />,
      title: t('help.categories.safety.title'),
      description: t('help.categories.safety.description'),
      link: '/safety'
    },
    {
      icon: <AssignmentIcon fontSize="large" />,
      title: t('help.categories.listings.title'),
      description: t('help.categories.listings.description'),
      link: '/help/listings'
    },
    {
      icon: <ContactSupportIcon fontSize="large" />,
      title: t('help.categories.support.title'),
      description: t('help.categories.support.description'),
      link: '/contact'
    }
  ];

  return (
    <>
      <SEO 
        title={t('help.title')}
        description={t('help.description')}
      />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          {t('help.title')}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" align="center" sx={{ mb: 6 }}>
          {t('help.subtitle')}
        </Typography>

        <Box sx={{ maxWidth: 600, mx: 'auto', mb: 6 }}>
          <TextField
            fullWidth
            placeholder={t('help.search.placeholder')}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Grid container spacing={3}>
          {categories.map((category, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {category.icon}
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {category.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, flexGrow: 1 }}>
                    {category.description}
                  </Typography>
                  <Button
                    component={Link}
                    to={category.link}
                    variant="outlined"
                    fullWidth
                  >
                    {t('help.learnMore')}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default HelpCenter; 